<template>

  <div class="bread-crumb-container d-flex">

    <!-- Navigation -->
    <v-slide-group
      multiple
      v-if          = "!isEntryManual"
      class         = "path-entry flex-grow-1"
    >
      <v-slide-item
        v-for       = "(element, index) in pathElements"
        :key        = "index"
      >

        <span class="element">
          <v-btn
            depressed
            text
            @click    = "$emit('folder', element.path);"
          >
            <v-icon v-if="element.icon">{{ element.icon }}</v-icon>
            {{ element.name }}
          </v-btn>

          <span class="divider">/</span>
        </span>

      </v-slide-item>

    </v-slide-group>

    <!-- Manual Entry -->
    <v-text-field
      v-else
      class         = "path-entry"
      color         = "accent"
      filled
      dense
      hide-details
      autofocus
      v-model                = "manualEntry"
      append-icon            = "mdi-arrow-right"
      @keydown.enter.prevent = "onOpenManualPath(manualEntry);"
      @click:append          = "onOpenManualPath(manualEntry);"
    >
    </v-text-field>

    <span class="spacer"></span>

    <!-- Manual Path Entry -->
    <v-btn
      icon
      :color      = "isEntryManual ? 'accent' : 'default'"
      @click      = "onToggleManualEntry();"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>

    <!-- List of Favorites -->
    <v-menu 
      offset-y 
      left
    >

      <template v-slot:activator="{on, attrs}">
        <v-btn
          icon
          v-bind    = "attrs"
          v-on      = "on"
          :disabled = "favorites.length === 0"
        >
          <v-icon>mdi-star</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          v-for  = "favorite in sortedFavorites"
          :key   = "favorite"
          @click = "$emit('folder', favorite);"
        >
          <v-list-item-content>{{ favorite }}</v-list-item-content>
        </v-list-item>
      </v-list>

    </v-menu>

  </div>
  
</template>

<script>

// #region Imports

/* Telestream */
import { isFolder } from '@/services/file-browser-service';

// #endregion Imports

export default {

  // #region Properties

  props: {
    path:      String,
    favorites: Array
  },
  data() {
    return {
      isEntryManual: false,
      manualEntry:   undefined
    };
  },
  computed: {
    pathElements() {
      const elements = [{
        icon: 'mdi-folder-home',
        path: undefined
      }];

      if (this.path) {
        const folders = this.path
          .split(/[\\]+/)
          .filter((folder) => folder.length > 0)
          .map((folder, index, original) => {
            return {
              name: folder,
              path: original.slice(0, index + 1).join('\\') + '\\'
            }
          });

        elements.push(...folders);
      }

      return elements;
    },
    sortedFavorites() {
      return this.favorites.slice().sort((a, b) => a.localeCompare(b, undefined, {'sensitivity': 'base'}));
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onToggleManualEntry() {
      this.manualEntry = this.path;
      this.isEntryManual = !this.isEntryManual;
    },

    async onOpenManualPath(path) {
      if (await isFolder(path)) {
        this.$emit('folder', path);
      } else {
        this.$emit('files', [path]);
      }
    },

    // #endregion Events

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.bread-crumb-container {

  .path-entry {
    width:            85%;
    height:           40px;
  }

  .element {
    display:          flex;
    flex-direction:   row;
    align-items:      center;

    .divider {
      margin:         0px 4px;
      color:          #97A7B2;
    }
  }
}

</style>
